module.exports = __webpack_public_path__ + "static/media/car-tilt.0fe1439d.svg";